// extracted by mini-css-extract-plugin
export default {"grid":"l4Pq4lEt","stale":"IlMTI2pJ","placeholder":"UP3V7xPh"};